import React, { Component } from 'react'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import Icon from "../icon/icon.component.jsx";
import {
    FormattedMessage,
    injectIntl,
} from 'react-intl'
import moment from "moment-timezone";
import CalendarModal from "../../calendar/modals/CalendarModal.component.jsx";
import EventBus from "../EventBus.js";
import { getEventName } from '../../name-helpers/eventNameHelper'
import { capitalize } from '../../name-helpers/nameFormatter'

const sortIsoDate = (a, b) => (a.attributes.startAt < b.attributes.startAt) ? -1 : ((a.attributes.startAt > b.attributes.startAt) ? 1 : 0)
class InlineEditAgenda extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            documentType: this.props.documentType || "",
            documentId: this.props.documentId || "",
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            elementIndexHover: -1,
            onChange: this.props.onChange || function () { },
            isLoading: false,
            success: false,
            elementsLimit: 1,
            currentLimit: 0,
            elements: [],
            invoiceId: this.props.invoiceId || '',
            quoteId: this.props.quoteId || '',
            orderId: this.props.orderId || '',
            contactId: this.props.contactId || '',
            userId: this.props.userId || '',
            projectId: this.props.projectId || '',
            project: this.props.project || null,
            identifier: this.props.identifier || '',
            nextEvent: null,
            quoteReferenceId: this.props.quoteReferenceId || '',
            orderReferenceId: this.props.orderReferenceId || '',
            location: this.props.location || null,
        }


        this.triggerEdit = this.triggerEdit.bind(this)
        this.renderEvent = this.renderEvent.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
        const defaultCallback = () => { }
        this.onSave = this.props.onSave || defaultCallback
        this.openCalendarModal = this.openCalendarModal.bind(this)
        this.refreshAgenda = this.refreshAgenda.bind(this)
    }

    componentDidMount() {
        this.refreshAgenda()
    }

    refreshAgenda() {
        AppContext.getApiClient().get(`/projects/${this.state.projectId}/calendar-events`).then(results => {
            EventBus.dispatch(EventBus.TopicDocumentCalendarEventsRefreshed, results.data)
            let events = results.data

            let currentLimit = this.state.currentLimit
            if (this.state.elements.length !== events.length && this.state.currentLimit) {
                currentLimit = events.length
            } else {
                currentLimit = currentLimit || (events && events.length < this.state.elementsLimit ? events.length : this.state.elementsLimit)
            }

            events = events.sort(sortIsoDate)
            let nextEvent = null
            for (let i = 0; i < events.length; i++) {
                events[i].attributes.isInThePast = true
                if (moment(events[i].attributes.startAt) > moment()) {
                    nextEvent = events[i]
                    events[i].attributes.isInThePast = false
                    break
                }
            }

            this.setState({
                elements: events,
                nextEvent: nextEvent,
                currentLimit: currentLimit,
                modal: '',
            })
        })
    }

    areOnTheSameDay(first, second) {
        return (first.getFullYear() === second.getFullYear() &&
            first.getMonth() === second.getMonth() &&
            first.getDate() === second.getDate())
    }


    onMouseEnterHandler(index) {
        this.setState({
            hover: true,
            elementIndexHover: index,
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false,
            elementIndexHover: -1,
        });
    }

    triggerEdit(event, calendarEventId) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode,
            modal: <CalendarModal
                calendarEventId={calendarEventId}
                projectId={this.state.projectId}
                project={this.state.project}
                onClose={this.refreshAgenda}
                proposal={this.props.proposal}
            />
        })
    }

    displayEventDatesInformation(event) {
        const localTimezone = moment.tz.guess()

        const startDate = moment(event.attributes.startAt).tz(localTimezone).format('LL')
        const endDate = moment(event.attributes.endAt).tz(localTimezone).format('LL')
        const startTime = moment(event.attributes.startAt).tz(localTimezone).format('LT')
        const endTime = moment(event.attributes.endAt).tz(localTimezone).format('LT')
        const timezoneAbbr = moment.tz(localTimezone).zoneAbbr()

        if (startDate === endDate) {
            return <div className="w-100">
                <Icon
                    value={"clock"}
                    className={'mr-2 text-secondary'} />
                {`${startDate} ${startTime} - ${endTime} ${timezoneAbbr}`}
            </div>
        }
        return <div className="w-100">
            <Icon
                value={"clock"}
                className={'mr-2 text-secondary'} />
            {`${startDate} ${startTime} - ${endDate} ${endTime} ${timezoneAbbr}`}
        </div>
    }

    renderEvent(ev, index) {
        const internalNotes = ev.attributes.project.attributes.internalNotes
        const lastInternalNote = internalNotes.length > 0 ?
            internalNotes[internalNotes.length - 1].attributes.notes : ''

        return <div key={ev.id} className={'w-100 d-flex p-2 '}>
            <div className={'min-width-zero'}>
                <h5 className={'m-0 border-0 text-left pb-0'}>
                    <span >
                        <Icon
                            value={"calendar-day"}
                            className={'mr-2 text-secondary'} />
                    </span>
                    {ev.attributes.title}
                </h5>
                <span className="text-left">
                    <p className={'m-0 text-secondary text-left text-truncate'}>
                        <Icon
                            value={"home"}
                            className={'mr-2 text-secondary'} />
                        {ev.attributes.location}
                    </p>
                    <p className={'m-0 text-secondary text-left'}>
                        {this.displayEventDatesInformation(ev)}
                    </p>
                </span>
                {
                    this.state.contactId !== ev.attributes.contactId &&
                    <span className="text-left">
                        <p className={'m-0 text-secondary text-left text-truncate'}>
                            <Icon
                                value={"user"}
                                className={'mr-2 text-secondary'} />
                            {ev.attributes.contact.attributes.name}
                        </p>
                    </span>
                }
                {
                    lastInternalNote &&
                    <span className="text-left">
                        <p className={'m-0 text-secondary text-left'}>
                            <Icon
                                value={"sticky-note"}
                                className={'mr-2 text-secondary'} />
                            {lastInternalNote}
                        </p>
                    </span>
                }
            </div>
            <div className={'ml-auto'}>
                <p className={'m-0 text-right mt-1 d-flex align-items-center'}>
                    {ev.attributes.isInThePast &&
                        <span className="badge badge-secondary text-with-icon">
                            <FormattedMessage
                                id="agenda.event.in_the_past_badge_label"
                                defaultMessage="Completed"
                            />
                        </span>
                    }
                    <span>
                        <a href={'#'} onClick={e => this.triggerEdit(e, ev.id)} onMouseEnter={() => this.onMouseEnterHandler(index)} onMouseLeave={this.onMouseLeaveHandler}>
                            {!this.state.success ?
                                <Icon value={'pencil-alt'} className={'ml-1 ' + ((!this.state.hover || index !== this.state.elementIndexHover) ? 'text-gray' : '')} /> :
                                <Icon value={'check'} className={'ml-1 ' + ((!this.state.hover || index !== this.state.elementIndexHover) ? 'text-success short-fade-out' : '')} />}
                        </a>
                    </span>
                </p>

            </div>
        </div>
    }

    openCalendarModal(event) {
        event.preventDefault()
        this.setState({
            modal: <CalendarModal
                invoiceId={this.state.invoiceId}
                quoteId={this.state.quoteId}
                orderId={this.state.orderId}
                onClose={this.refreshAgenda}
                contactId={this.state.contactId}
                userId={this.state.userId}
                projectId={this.state.projectId}
                project={this.state.project}
                identifier={this.state.identifier}
                proposal={this.props.proposal}
                location={this.state.location}
            />
        })
    }

    render() {
        let eventsToDisplay = this.state.elements.slice(0, this.state.currentLimit)
        if (this.state.nextEvent && this.state.currentLimit === 1) {
            eventsToDisplay = [this.state.nextEvent]
        }
        var result = (
            [
                this.state.modal || '',
                <div className="d-flex justify-content-between mt-1">
                    <label className="col-form-label custom-form-label project-details-label pt-0">
                        <FormattedMessage
                            id="invoice.edit.invoice_info.agenda_events"
                            defaultMessage="Agenda {eventName}s"
                            values={{ eventName: getEventName(this.props.intl) }}
                        /> {this.state.elements.length > 0 ? <span>({this.state.elements.length})</span> : ''}
                    </label>
                    <button
                        className={'btn btn-sm btn-primary ' + (this.state.elements.length > 0 ? 'mb-2' : '')}
                        onClick={this.openCalendarModal}
                    >
                        <Icon value={"plus"} className={"mr-1"} />
                        <small>
                            <FormattedMessage
                                id="agenda.add_event_button"
                                defaultMessage="Add {eventName}"
                                values={{ eventName: capitalize(getEventName(this.props.intl)) }}
                            />
                        </small>
                    </button>
                </div>,
                <div className="text-center mb-1">
                    {
                        eventsToDisplay.map((ev, index) => {
                            return <li className="list-group-item" style={{ "padding": "0 1.2rem" }} key={ev.id}>
                                <div className="row">
                                    {this.renderEvent(ev, index)}
                                </div>
                            </li>
                        })
                    }
                    <span>
                        {
                            this.state.elements && this.state.elements.length > this.state.elementsLimit && (this.state.currentLimit <= this.state.elementsLimit) &&
                            <small className="text-primary">
                                <a href={'#'} onClick={() => {
                                    this.setState({
                                        currentLimit: this.state.elements.length,
                                    })
                                }}>
                                    <FormattedMessage
                                        id="invoice.analytics.see_all"
                                        defaultMessage="See all ({count})"
                                        values={{
                                            count: this.state.elements.length,
                                        }}
                                    />
                                    <Icon value={'arrows-alt-v'} />
                                </a>
                            </small>
                        }
                        {
                            this.state.currentLimit > this.state.elementsLimit &&
                            <small className="text-primary">
                                <a href={'#'} onClick={() => {
                                    this.setState({
                                        currentLimit: 1,
                                    })
                                }}>
                                    <FormattedMessage
                                        id="invoice.analytics.hide"
                                        defaultMessage="Hide"
                                    />
                                    <Icon value={'arrows-alt-v'} />
                                </a>
                            </small>
                        }
                    </span>
                </div>])

        return result
    }

}

export default injectIntl(InlineEditAgenda)





// WEBPACK FOOTER //
// ./src/common/inline-edit/agenda.component.jsx